import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DuplicateVatRateError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.fiscalization.validation.vat-rate-id.duplicates');
    }
}
